const base = {
  logo: "Reset your password",
  fields: {
    newPassword: {
      info: "",
      label: "New password",
      required: "The field cannot be empty",
      placeholder: ""
    },
    repeatPassword: {
      info: "",
      label: "Repeat password",
      required: "The field cannot be empty",
      placeholder: ""
    }
  },
  reset: {
    label: "Reset Password",
    tooltip: "Click to reset your password"
  },
  resetDescription: "After the submission you will be redirected to login.",
  passwordMismatchError: "Password must not mismatch"
};
function getDefaultTexts(texts) {
  const resetPassword = texts?.fields?.newPassword;
  const resetRepeatPassword = texts?.fields?.repeatPassword;
  const resetLogo = texts?.logo;
  const resetBtn = texts?.reset;
  const resetDesc = texts?.resetDescription;
  const passwordMismatchError = texts?.passwordMismatchError;
  return {
    logo: resetLogo ?? base.logo,
    fields: {
      newPassword: {
        info: resetPassword?.info ?? base.fields.newPassword.info,
        label: resetPassword?.label ?? base.fields.newPassword.label,
        required: resetPassword?.required ?? base.fields.newPassword.required,
        placeholder: resetPassword?.placeholder ?? base.fields.newPassword.placeholder
      },
      repeatPassword: {
        info: resetRepeatPassword?.info ?? base.fields.repeatPassword.info,
        label: resetRepeatPassword?.label ?? base.fields.repeatPassword.label,
        required: resetRepeatPassword?.required ?? base.fields.repeatPassword.required,
        placeholder: resetRepeatPassword?.placeholder ?? base.fields.repeatPassword.placeholder
      }
    },
    reset: {
      label: resetBtn?.label ?? base.reset.label,
      tooltip: resetBtn?.tooltip ?? base.reset.tooltip
    },
    resetDescription: resetDesc ?? base.resetDescription,
    passwordMismatchError: passwordMismatchError ?? base.passwordMismatchError
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
